import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/activo/importer/activoImporterActions';

export default importerReducers(actions);
